import {IRegistryOperator} from "../../../../../types/registry";

export default {
	firstname: "",
	surname: "",
	fiscal_code: "",
	email: "",
	phone: "",
} as IRegistryOperator;
